module.exports = __webpack_public_path__ + "static/media/Step3.6.54ea3219.png";